module.exports = __webpack_public_path__ + "img/lixeira.b61793e1.svg";